function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-23{fill:#6c63ff;}.cls-2{opacity:0.4;}.cls-12,.cls-13,.cls-2,.cls-9{isolation:isolate;}.cls-3{fill:#efffb4;}.cls-4{fill:#3f3d56;}.cls-5{fill:#aad9ff;}.cls-6{fill:#b4cdff;}.cls-7{fill:#2f2e41;}.cls-8{fill:#ffb8b8;}.cls-9{opacity:0.1;}.cls-10{fill:#d0cde1;}.cls-11,.cls-13{fill:#ff9fc2;}.cls-12{fill:#ff74d6;}.cls-12,.cls-13{opacity:0.2;}.cls-14{fill:#f4ffdf;}.cls-15{fill:#e3a3ff;}.cls-16{fill:#ffbfe6;}.cls-17{fill:#f2f2f2;}.cls-18,.cls-20{fill:#ffcde0;}.cls-19{fill:#21609b;}.cls-20{stroke:#fff;stroke-miterlimit:10;}.cls-21{fill:#ecffbf;}.cls-22{fill:#ffb4e6;}.cls-24{fill:#ffb4fb;}.cls-25{fill:#ff9ff8;}.cls-26{fill:#b4e0ff;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  y: -0.7,
  width: 583.9,
  height: 653.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 137,
  cy: 553.2,
  r: 14.9,
  transform: "translate(-420.45 671.71) rotate(-88.09)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 109.4,
  cy: 560.3,
  r: 10.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M531,349.3a255.57,255.57,0,0,0-17.9-224.8L105,181,496.1,99.5A254.36,254.36,0,0,0,294,0C153.2,0,39,114.2,39,255a253.31,253.31,0,0,0,2.4,34.8Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M56,346.8C92.9,442.3,185.5,510,294,510A254.88,254.88,0,0,0,524.5,364.1Z"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 106,
  cy: 112,
  r: 12
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 538,
  cy: 252,
  r: 12
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 105,
  y: 339,
  width: 20,
  height: 20
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M268,193s33-14.4,48.5.8S275,204,268,193Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M325,124.8c-11.1-18.7-33-19.6-33-19.6s-21.4-2.7-35.1,25.8c-12.8,26.6-30.4,52.3-2.8,58.5l5-15.5,3.1,16.7a116.16,116.16,0,0,0,11.8.2c29.5-1,57.7.3,56.8-10.3C329.5,166.5,335.7,142.8,325,124.8Z"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-4",
  cx: 294.5,
  cy: 398,
  rx: 56,
  ry: 13
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 285.41,
  y: 559.52,
  width: 54.1,
  height: 2,
  transform: "translate(-40.48 24.57) rotate(-4.23)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 258.49,
  y: 545.59,
  width: 2,
  height: 22.8,
  transform: "translate(-353.61 515.94) rotate(-61.19)"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 288.5,
  y: 543.5,
  width: 18,
  height: 2
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "241.5 650.6 239.5 650.4 254.5 418.4 256.5 418.6 241.5 650.6"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "315.5 650.5 305.5 422.5 307.5 422.5 317.5 650.5 315.5 650.5"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 343,
  y: 420.1,
  width: 2,
  height: 230.8,
  transform: "translate(-42.92 30.14) rotate(-4.72)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M340.5,464.5s-14,26-23,26-8,17-6,21,7,13-1,26c-2.8,4.5-2.3,9.7-.5,14.5,5.1,13.4,25.1,9.3,24.5-5v-.5c-1-16,7-41,15-47s15-22,15-22Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M244.5,458.5s14,26,23,26,8,17,6,21-7,13,1,26c2.8,4.5,2.3,9.7.5,14.5-5.1,13.4-25.1,9.3-24.5-5v-.5c1-16-7-41-15-47s-15-22-15-22Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M255.5,330.5l-6,13s-88,29-80,63,47,87,53,85,38-8,39-25-23-47-23-47l33-30,48-1,41,31s-43,38-24,53,47,25,51,19,49-95,42-103-78-38-78-38l-19-27-74-4Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M273.5,165.5s5,33-5,37,20,21,20,21h17l11-23s-10-18-4-35S273.5,165.5,273.5,165.5Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M273.5,165.5s5,33-5,37,20,21,20,21h17l11-23s-10-18-4-35S273.5,165.5,273.5,165.5Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M266.5,193.5s11,12,13,14,11,13,30-3,21,3,21,3v120s-16-7-29,0-40-2-40-2l-5-124Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M273.8,193.5s-9.3-4-17.3,0-36,24-34,33,28,72,10,102-21,38-21,38l44-23s34-21,31-34S273.8,193.5,273.8,193.5Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M313.5,193.5s21,2,22,4S367,208,365,217s-29.5,89.5-17.5,104.5,32,36,25,38-19-3-31,0-40-22-37-49S304.5,200.5,313.5,193.5Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M263.5,384.5v10s-5,23,11,22,6-28,6-28l-1-9Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M308.5,385.5s-11,23,0,25,19-13,19-17S308.5,385.5,308.5,385.5Z"
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "272.5 650.5 270.5 650.5 276.5 420.5 278.5 420.5 272.5 650.5"
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-8",
  cx: 323,
  cy: 152,
  rx: 2,
  ry: 4
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-8",
  cx: 264,
  cy: 152,
  rx: 2,
  ry: 4
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M340.5,206.5s25,0,24,10-34,182-34,182-14-13-26-10Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M243.5,209.5s-25,5-25,20,36,159,41,159,24-3,24-8S243.5,209.5,243.5,209.5Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M249,239l22.5,88S261,250,249,239Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M336.5,226.6l-22.8,115C313.8,341.7,321,233.3,336.5,226.6Z"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-8",
  cx: 293.5,
  cy: 152.5,
  r: 29
});

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "320.1 123 298.4 111.6 268.5 116.3 262.3 143.6 277.7 143 282 133 282 142.9 289.1 142.6 293.2 126.6 295.8 143.6 321.1 143.1 320.1 123"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 10,
  y: 650,
  width: 546,
  height: 2
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M464.6,650h-2a461.76,461.76,0,0,1,7.1-66.3c8.6-46.9,23-77.7,42.7-91.5l1.1,1.6C467.5,526.2,464.6,648.8,464.6,650Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M489.6,649.5h-2c0-2.2,1.3-54.4,21.8-68.8l1.1,1.6C490.9,596.1,489.6,649,489.6,649.5Z"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-15",
  cx: 525,
  cy: 483,
  r: 10
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-15",
  cx: 520,
  cy: 570,
  r: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M484.9,500c1.9,12-3,22.7-3,22.7S474,514,472.1,502s3-22.7,3-22.7S483,488,484.9,500Z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M517.6,529.1c-11.5,3.9-22.9,1-22.9,1s7.2-9.3,18.7-13.3,22.9-1,22.9-1S529.1,525.2,517.6,529.1Z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M518,605.3a31.38,31.38,0,0,1-16.1.7,28.36,28.36,0,0,1,29.2-10A31.23,31.23,0,0,1,518,605.3Z"
});

var _ref47 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "2 193.3 0 193.3 0 64 127.3 64 127.3 66 2 66 2 193.3"
});

var _ref48 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "583.9 192 581.9 192 581.9 64 455.9 64 455.9 62 583.9 62 583.9 192"
});

var _ref49 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "2 302.7 0 302.7 0 432 127.3 432 127.3 430 2 430 2 302.7"
});

var _ref50 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "580.7 302.7 578.8 302.7 578.8 430 453.4 430 453.4 432 580.7 432 580.7 302.7"
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 36,
  y: 123,
  width: 140,
  height: 2
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 74,
  y: 105,
  width: 2,
  height: 18.5
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 135,
  y: 105,
  width: 2,
  height: 18.5
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 414,
  y: 264,
  width: 140,
  height: 2
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 452,
  y: 246,
  width: 2,
  height: 18.5
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 513,
  y: 246,
  width: 2,
  height: 18.5
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 45,
  y: 358,
  width: 140,
  height: 2
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 83,
  y: 340,
  width: 2,
  height: 18.5
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 144,
  y: 340,
  width: 2,
  height: 18.5
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M69.2,560.6c0,31.2-14.2,42.1-31.7,42.1H36.3c-.8,0-1.6-.1-2.4-.1-15.8-1.5-28-12.9-28-41.9,0-30,29.3-67.9,31.5-70.7h0a.31.31,0,0,0,.1-.2S69.2,529.4,69.2,560.6Z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M37,597.9l11.6-21.2L37,600.2v2.4c-.8,0-1.6-.1-2.4-.1l1.2-31.2v-.2h0l.1-2.9L24.3,544.7,36,565.9v.6l.9-23.6-10-24.3L37,538.8,38,490v0l-.2,38.5,9.9-15.3-10,18.6-.3,21.1,9.3-20.2L37.5,556l-.1,11.7,13.4-28.2L37.3,571.8Z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M121,604.6c0,18.7-8.5,25.2-19,25.2h-.7a6.15,6.15,0,0,1-1.4-.1C90.4,628.9,83,622,83,604.6c0-18,17.6-40.7,18.9-42.3h0l.1-.1S121,586,121,604.6Z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M101.7,627l6.9-12.7-7,14.1v1.5a6.15,6.15,0,0,1-1.4-.1l.7-18.7V611h0l.1-1.8-7-14.1,7,12.8v.4l.6-14.1-6-14.6,6,12.1.6-29.3v0l-.1,23.1,5.9-9.2-6,11.1V600l5.5-12.1-5.6,14-.1,7L110,592l-8.1,19.3Z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M546.3,195.8H553s-12.4,17.8-13.4,19.3a9.06,9.06,0,0,0-1.1,1.6,40.71,40.71,0,0,0-1.3,5h-6.1a24,24,0,0,0,.9-5.5c0-1.7-.8-3.4-1.3-5s-1.1-5-1.1-5h6.3l.9,3.7,9.5-14.1"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M532.6,198.1c1.4.8,2.2,5,2.2,5s-7.3.1-11.3.1h-3.4l-4.2,16.6h-6.4s4-18,4.9-21.3c.3-1.1,2.1-.9,5.1-.9h4.8c3.2,0,6.8-.3,8.3.5M503,206.2a3.31,3.31,0,0,0-.7-2.3c-.7-1.1-1.4-1.3-3.4-1.4-5.5-.2-5.4,3.6-5.4,3.6Zm6-4.3c.8,2.7-.7,9-.7,9s-8.1-.1-12.5,0c-1.4,0-3-.1-3.4.4-.6.8.2,2.1.9,2.6a5.48,5.48,0,0,0,2.8.7,105.2,105.2,0,0,0,11.1.1l-1.3,5.3s-10.6.5-15.9-.7a6.19,6.19,0,0,1-2.7-1.3c-.2-.2-.3-.4-.5-.6a4.73,4.73,0,0,1-.7-1.2c-1.2-3,.1-8.6,1.5-11.6a6.72,6.72,0,0,1,.6-1.2c.3-.5.5-1,.7-1.3s.3-.3.4-.5.3-.4.5-.6a7,7,0,0,1,1.7-1.3c2.2-1.5,6.2-2.7,11-2.2,1.8.2,4.5.8,5.9,2.5.2.5.4,1.2.6,1.9Zm-29.3-4.3h6.2s-3.4,14.9-5.2,22.2h-7.1c-5,0-9.4.6-11.3-2.7s-.1-8.3.7-11.9c.6-2.5,1.8-7.6,1.8-7.6l6.4-.1s-1.8,7.9-2.6,11.9c-.3,1.4-.8,2.8-.2,3.8s1.3,1.1,3.7,1.1h3.2l4.4-16.7m-28.9,10.8c.6-2.1,1.6-4.4,1.5-6.3a5.6,5.6,0,0,0-3.2-4.3,8.62,8.62,0,0,0-8.3,1.8c-1.7,1.7-2.3,3.7-2.9,6.5-.5,2.1-.8,4.2,0,5.8,1.5,2.8,6.1,2.2,11,2.2.7-1.7,1.3-3.7,1.9-5.7Zm8.6-8.3c.7,4.7-2,9.9-3.9,14.4,1.9.2,3.6,0,3.7.1s-1.3,5.4-1.8,5.4c-1.5,0-6.5.1-8.6.1-6.8,0-13.2.4-16.4-2.7a9.6,9.6,0,0,1-2.5-4.9,19.51,19.51,0,0,1,.7-7.6,18.55,18.55,0,0,1,2.5-5.8c2.9-4.6,7.8-7.9,16.2-7.2a14.66,14.66,0,0,1,5.4,1.6c.1.1.5.3.5.4a9,9,0,0,1,4.2,6.2Zm-30.1-2.5c-.4,1.7-.8,3.7-1.3,5.3h-6.9c.5-1.9.9-3.7,1.5-5.4,2.3.1,4.3.1,6.7.1m-8.4,7h6.6c-.9,4.4-2.6,11.4-3.9,16.4-.8,3.1-1.4,5.3-3.7,6.9-.2.1-.3.1-.5.2a9.27,9.27,0,0,1-3.4.9,58.05,58.05,0,0,1-5.9,0c.6-1.9,1.2-4.1,1.7-5.8,5.2.6,5.4-3.9,6.4-8.3.6-2.6,2.4-9.3,2.7-10.3"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M395.2,217.8l-.3.1c-4.6,1-8.6-.1-11.1-3.7a10.36,10.36,0,0,1-1.7-5.2,16.56,16.56,0,0,1,3.1-9.6c2.8-4,8-7.8,14-7.2l-1.1.2-.4.2c-10.8,3.8-14.1,16-8.8,22.2a9.65,9.65,0,0,0,6.3,3"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M395.3,207.6a7,7,0,0,0,5.5,2.9,7.2,7.2,0,0,1-9.1-4.3c-1.4-3.3.6-8.8,4.4-11.7a12.1,12.1,0,0,1,7.9-2.6,10,10,0,0,0-2.9,1c-6.6,3.6-8.2,10.8-5.8,14.7"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M404.9,204.2a6.9,6.9,0,0,1-4.1-.8c-2.5-2.2-2-5-.7-7.1a10.59,10.59,0,0,1,1-1.2c1.3-1.4,3.8-2.7,5.7-2.5a9.4,9.4,0,0,0-3.5,2,15.58,15.58,0,0,0-1.6,2,6,6,0,0,0-.8,2.8v1.1c.2.9.5,2.7,4,3.7"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M115.1,268.4c-.8-.3-1.5-.7-2.3-1,.1-.7.3-1.4.4-2.1,1.8-11.1.7-20-3.2-23-3.7-2.8-9.9.1-16.1,7.1l-1.8,2.1a17.41,17.41,0,0,0-1.2-1.4c-6.5-7.5-12.9-10.7-16.8-7.8-3.7,2.8-4.9,11.2-3.3,21.7.2,1,.3,2.1.5,3.1-.9.3-1.8.7-2.7,1.1-7.6,3.4-12.5,8.8-12.5,14.5s5.2,11.7,13.1,15.2a15.39,15.39,0,0,0,1.9.8l-.6,3.3c-1.5,10.3-.4,18.5,3.3,21.4s10.3,0,16.6-7.2l1.5-1.8c.6.8,1.3,1.6,1.9,2.3,6.1,6.9,12.1,9.7,15.8,6.9,3.9-2.9,5.1-11.7,3.5-22.4-.1-.8-.3-1.7-.4-2.5a11.22,11.22,0,0,1,1.3-.5c8.2-3.5,13.6-9.3,13.6-15.1.3-5.7-4.7-11.2-12.5-14.7Z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M112.9,293.9c-.4.2-.8.3-1.2.5a117,117,0,0,0-3.6-11.9,112.93,112.93,0,0,0,3.5-11.7l2.1.9c6.6,3,10.7,7.4,10.7,10.8,0,3.7-4.4,8.4-11.5,11.4Zm-3,7.6a43.84,43.84,0,0,1,.3,12.4c-.4,3-1.3,5-2.4,5.8-2.3,1.7-7.1-.5-12.3-6.4-.6-.7-1.2-1.4-1.8-2.2a82.7,82.7,0,0,0,6-10,53.67,53.67,0,0,0,9.7-1.9,10.61,10.61,0,0,1,.5,2.3ZM80.1,319.3c-2.2,1-4,1-5,.2-2.3-1.7-3.2-8.3-1.9-17.1.2-1,.3-2.1.5-3.1a64,64,0,0,0,9.7,1.9,111,111,0,0,0,6.1,10,10.7,10.7,0,0,1-1.4,1.6,24.84,24.84,0,0,1-8,6.5ZM69.8,293.7a26,26,0,0,1-8.4-5.8c-1.8-2-2.7-4-2.7-5.6,0-3.4,3.9-7.8,10.4-10.7a18.61,18.61,0,0,1,2.5-1c1,4,2.1,8,3.5,11.9a118.83,118.83,0,0,0-3.6,12C71,294.2,70.4,294,69.8,293.7Zm3.6-30.8c-1.3-9-.4-15.8,1.8-17.5,2.4-1.8,7.7.8,13.3,7.3.4.4.7.9,1.1,1.3a82,82,0,0,0-6.1,9.9,65.17,65.17,0,0,0-9.6,1.9c-.2-1-.4-2-.5-2.9ZM104.3,273c-.7-1.6-1.4-3.2-2.2-4.7a56.55,56.55,0,0,1,6.5,1.5c-.7,2.7-1.4,5.4-2.3,8.1-.6-1.7-1.3-3.3-2-4.9ZM91.7,256.9a75.65,75.65,0,0,1,4.2,6.7,60.28,60.28,0,0,0-8.5,0,78.16,78.16,0,0,1,4.3-6.7ZM79,272.9c-.7,1.6-1.4,3.2-2,4.8-.9-2.8-1.6-5.5-2.3-8.1a41.38,41.38,0,0,1,6.5-1.4C80.4,269.7,79.7,271.3,79,272.9Zm2.2,23.9a51.76,51.76,0,0,1-6.6-1.4c.6-2.7,1.4-5.4,2.3-8.3.6,1.6,1.3,3.3,2,4.9S80.4,295.3,81.2,296.8Zm10.5,11.4c-1.4-2.1-2.9-4.3-4.3-6.8,1.4.1,2.8.1,4.2.1s2.9,0,4.3-.1C94.6,303.8,93.1,306.1,91.7,308.2Zm14.6-21.1c.9,2.7,1.7,5.5,2.4,8.3-2.2.6-4.4,1.1-6.7,1.5.8-1.6,1.5-3.2,2.2-4.8A44,44,0,0,0,106.3,287.1Zm-4.7,3a80,80,0,0,1-3.5,7.2q-3.15.3-6.6.3c-2.2,0-4.4-.1-6.5-.3-1.2-2.4-2.4-4.8-3.5-7.3s-2.1-5-3-7.6c1-2.6,2-5.1,3.1-7.5h0c1.1-2.5,2.3-4.9,3.5-7.2,2.1-.2,4.3-.3,6.5-.3a46.32,46.32,0,0,1,6.5.4c1.2,2.4,2.4,4.8,3.4,7.2s2.1,5,3.1,7.5c-.9,2.6-1.9,5.1-3,7.6Zm6.4-44.7c2.4,1.8,3.3,9.1,1.8,18.7-.1.6-.2,1.2-.3,1.9a65.57,65.57,0,0,0-9.6-2,96.37,96.37,0,0,0-6-9.9c.5-.7,1.1-1.3,1.7-2,5.2-6.1,10.2-8.4,12.4-6.7Z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M92,274.6c3.5,0,6.4,3.8,6.4,8.4s-2.9,8.4-6.4,8.3-6.4-3.8-6.4-8.4h0c0-4.6,2.9-8.3,6.4-8.3h0"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M86.7,627.5h30.6c4.2,0,7.5,4.4,7.5,9.9v5.7c0,5.4-3.4,9.9-7.5,9.9H86.7c-4.2,0-7.5-4.4-7.5-9.9v-5.7C79.2,631.9,82.6,627.5,86.7,627.5Z"
});

var _ref73 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-22",
  x: 1.1,
  y: 346.9,
  width: 16.5,
  height: 85.6
});

var _ref74 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-23",
  x: 1.1,
  y: 359,
  width: 16.5,
  height: 4
});

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-23",
  x: 1.1,
  y: 417,
  width: 16.5,
  height: 4
});

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 13.5,
  y: 346.9,
  width: 4.1,
  height: 85.6
});

var _ref77 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-22",
  x: 16,
  y: 345.6,
  width: 16.5,
  height: 85.6
});

var _ref78 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-23",
  x: 15.6,
  y: 359,
  width: 16.5,
  height: 4
});

var _ref79 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-23",
  x: 15.6,
  y: 417,
  width: 16.5,
  height: 4
});

var _ref80 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 27,
  y: 346.9,
  width: 4.1,
  height: 85.6
});

var _ref81 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-22",
  points: "30.8 349.8 46.7 344.2 63.6 426.9 47.6 432.5 30.8 349.8"
});

var _ref82 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-23",
  points: "34.2 366.8 50.1 361.2 50.9 365.1 35 370.7 34.2 366.8"
});

var _ref83 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-23",
  points: "45 417.5 61 412 61.8 415.9 45.8 421.4 45 417.5"
});

var _ref84 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "43.2 345.6 47.2 344.2 64 426.9 60 428.3 43.2 345.6"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M7.6,603H67.4s11.8,19.7-6.5,49H13.7S-3.4,631.7,7.6,603Z"
});

var _ref86 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-24",
  x: 165.7,
  y: 66.3,
  width: 21.7,
  height: 20.4
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M197.1,78.7H170.8V53.9h26.3Zm-25.2-1.1h24V55h-24Z"
});

var _ref88 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-25",
  points: "122.8 99.8 128.8 119.4 108 125 102 105.4 122.8 99.8"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M113.7,119.8,106.5,96l25.3-6.8L139,113Zm-5.8-23,6.6,21.7,23.1-6.2L131,90.6Z"
});

var _ref90 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-24",
  points: "149.3 13.2 134.5 28.1 118.7 14.2 133.5 -0.7 149.3 13.2"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M112,28.7l18-18.1,19.2,16.9-18,18.1Zm18-16.5L113.6,28.7l17.6,15.4,16.4-16.5Z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M502.5,412.9a22.14,22.14,0,0,1-3.3,12c-2.1,3-4.5,4.5-7.3,4.5-2.3,0-4.3-1.5-6.1-4.4s-2.6-7.5-2.6-13.6c0-1.4,0-2.7.1-3.9s.1-2.4.2-3.5l1.5-16H474.9c-1.8,20.2-3.2,32.2-4.3,36s-3,5.7-5.7,5.7a4.41,4.41,0,0,1-3.2-1.5,5.27,5.27,0,0,1-1.5-4c0-1.5,1.1-3.6,3.2-6.2s3.3-5.1,3.5-7.3l2.6-22.7h-4.3a6.65,6.65,0,0,0-3.4.9,7.51,7.51,0,0,0-2.5,2.2l-1.9,3.1h-1.5c1.4-4.9,3.2-8.6,5.3-11.1a9.19,9.19,0,0,1,7.2-3.7h33.5v8.5H490.6c-.4,3.9-.6,7.8-.8,11.6s-.3,7.8-.3,11.7a11,11,0,0,0,1.7,6.4,5,5,0,0,0,4.2,2.5,5.28,5.28,0,0,0,3.2-1.4,5,5,0,0,0,1.9-3.6,14.93,14.93,0,0,0,.2-1.7,5.38,5.38,0,0,1,.1-.8Z"
});

var SvgLanding = function SvgLanding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb414a8b-d0ff-4841-818a-532ec941ba8d",
    viewBox: "0 0 583.9 652",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/landing.c0047981.svg";
export { ForwardRef as ReactComponent };